var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2ToiletsRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM46.29 40H41V24.71A2.71 2.71 0 0143.71 22h2.58A2.71 2.71 0 0149 24.71v12.58A2.71 2.71 0 0146.29 40zM23 43h21v17h-9V50h-3.22C27.16 50 23 46.61 23 43zm-2.33-6H38v3H20.67a1.5 1.5 0 010-3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Toilets_room.2344b944.svg";
export { SvgE2ToiletsRoom as ReactComponent };